import Layout from "../components/Layout";

const About = () => {
  return (
    <Layout>
      <section className="About">
        <h3>In the beginning ...</h3>
        <p>
          So it all began when Margaret gave her brother Nate{" "}
          <a
            href="https://www.abebooks.com/Creature-Paintings-Drawings-Reflections-Tan-Shaun/31327510379/bd?cm_mmc=ggl-_-US_Shopp_Trade_20to50-_-product_id=COM9781646142002USED-_-keyword=&gclid=CjwKCAiA-8SdBhBGEiwAWdgtcDuQHuN2L-SYFEcI36OQTPI7IiuPefoHm0Qo29ijftIaUaPt1rCtURoCfZgQAvD_BwE"
            target="_blank"
          >
            <i>Creatures</i>
          </a>{" "}
          by Shaun Tan for Christmas, 2022.
        </p>
        <p>
          They both so enjoyed this book that they decided to start a sketch
          trade of their <em>own</em> creatures. At some point in the
          conversation, Nate, who has made websites before, thought maybe they
          should invite some friends to participate. Nate and Margaret had been
          enjoying enough Christmas wine at this point to just buy the domain
          name on the spot.
        </p>

        <p>
          (Of course we are not the first ones to plug "creature" in to "party"
          and make a website. It turns out{" "}
          <a href="http://creatureparty.com/" target="_blank">
            the .com party was already started
          </a>{" "}
          by the Finnish/German artist & Illustrator{" "}
          <a href="http://katihyyppa.com">Kati Hyyppä</a>, and we both highly
          recommend you go check it out.)
        </p>

        <h3>Version 1</h3>

        <p>
          The first set of creature parties were scheduled for each week of
          2023. Then, after nine glorious weeks, we stopped. It turns out that
          parties more work than we had anticipated.
        </p>
        <h3>Version 2</h3>

        <p>
          Fast forward to 2026. we're starting again, this time on a{" "}
          <em>monthly</em> schedule to keep things a bit more manageable. You
          can see a schedule of this year's parties{" "}
          <a
            href="https://docs.google.com/document/d/1I404mJkfQgxhobhHmHavIVPxx8t5YLckQHEnoCVsh24/edit?tab=t.0"
            target="_blank"
          >
            here
          </a>
          .
        </p>
      </section>
    </Layout>
  );
};

export default About;
